module.exports = __webpack_public_path__ + "static/img/Android.915a2d67.png";